export enum VideoActiveTab{
    Q_AND_A ="Q & A",
    READING_MATERIAL ="Reading Material",
}
export enum VideoVisibilityEnum{
    Draft ="Draft",
    Published ="Published",
}
export enum CommercialUserStatus{
    Deleted ="Deleted",
    Active="Active",
}
export enum ShowUserStatus{
    Delete ="Delete",
    Active="Active",
}
export enum CouponGenerationType {
  printed = "printed",
  admin = "admin",
}
export enum Gender {
  MALE = "Male",
  FEMALE = "Female",
}
export enum DcddMembershipStatus {
  Active = "Active",
  Inactive = "Inactive",
}
export enum SpecialOfferStatus {
  Active = "Active",
  InActive = "InActive",
}
export enum CheyCheyImageType {
  Preview = "Preview",
  Slider = "Slider",
}

export enum DcddRegistrationCategory {
  HOME = "home",
  ECCD = "eccd",
  STUDENT = "student",
  ECCD_FACILITATOR = "eccd facilitator",
  DZONGKHA_TEACHER = "dzongkha teacher",
}

export enum VideoFeaturedEnum{
    false ="false",
    true="true",
}
export const featuredOptions = [
  { label: "Featured", value: VideoFeaturedEnum.true },
  { label: "Not Featured", value: VideoFeaturedEnum.false },
];

export enum FeaturedAdsEnum{
    video ="video",
    image="image",
}
export enum FeaturedAdsStatusEnum{
    Published ="Published",
    Draft="Draft",
}
export enum SuperAdminStatusEnum{
    SuperAdmin ="super admin",
}